module.exports = {
  form_already_submitted: 'Du hast dieses Formular bereits abgeschickt.',
  submission_error: 'Das Formular konnte nicht versendet werden. Bitte versuche es später erneut.',
  next: 'Weiter',
  field_is_required: 'Bitte fülle dieses Feld aus',
}
